import { Navigate } from 'react-router-dom'

function Home() {
  return <Navigate to="/indicadores" />
}

export default Home